import dark from './dark';

const primary = (params) => dark(params, true);

export default primary;
